<!-- eslint-disable -->
<script setup>
import { ref, computed, onBeforeMount, watch, onUnmounted, onMounted } from 'vue';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useI18n } from 'vue-i18n';
import { useRegionsStore } from '@/stores/regions';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useRouter, useRoute } from 'vue-router';
import { useInitializeStore } from '@/stores/initialize';
import { useCouponsStore } from '@/stores/coupons'
import DayTimeFilter from './DayTimeFilter.vue';
import CompetitionFilter from './CompetitionFilter.vue';
import SortFilter from './SortFilter.vue';
import moment from 'moment';
import _ from 'lodash';

const router = useRouter();
const route = useRoute();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();
const regionsStore = useRegionsStore();
const preSportsStore = usePreSportsStore();
const initializeStore = useInitializeStore();
const couponsStore = useCouponsStore();

const { t } = useI18n();
const window_height = ref(window.innerHeight);

const showTranslatedDateFilter = computed(() => {
	if (dateTimeSportFiltersStore.selected_option === 'all') return t('general.all');
	if (dateTimeSportFiltersStore.selected_option.includes('_hours')) return t('day_time_selector.next_' + dateTimeSportFiltersStore.selected_option);
	else return t('days.' + dateTimeSportFiltersStore.selected_option);
});

const totalSelectedCompetitions = computed(() => {
	return dateTimeSportFiltersStore.selected_regions.reduce((total, region) => {
		return total + region.competition_ids.length;
	}, 0);
});

const toggleFilter = (filter_name) => {
	dateTimeSportFiltersStore.expand_datetime = filter_name === 'datetime' ? !dateTimeSportFiltersStore.expand_datetime : false;
	dateTimeSportFiltersStore.expand_competitions = filter_name === 'competitions' ? !dateTimeSportFiltersStore.expand_competitions : false;
	dateTimeSportFiltersStore.expand_sort = filter_name === 'sort' ? !dateTimeSportFiltersStore.expand_sort : false;

	const is_any_filter_open = dateTimeSportFiltersStore.expand_datetime || dateTimeSportFiltersStore.expand_competitions || dateTimeSportFiltersStore.expand_sort;

	if (is_any_filter_open) document.body.classList.add('filters-show');
	else document.body.classList.remove('filters-show');
};

// Also, update the backdrop click to close everything
const closeAllFilters = () => {
	document.body.classList.remove('filters-show');
	dateTimeSportFiltersStore.expand_datetime = false;
	dateTimeSportFiltersStore.expand_competitions = false;
	dateTimeSportFiltersStore.expand_sort = false;
};

watch(() => dateTimeSportFiltersStore.selected_regions, () => {
	const is_any_filter_open = dateTimeSportFiltersStore.expand_datetime || dateTimeSportFiltersStore.expand_competitions || dateTimeSportFiltersStore.expand_sort;

	if (is_any_filter_open) {
		let comp_ids = [];
		for (const key in dateTimeSportFiltersStore.selected_regions) {
			comp_ids.push(...dateTimeSportFiltersStore.selected_regions[key].competition_ids)
		}

		let params = router.currentRoute.value.params
		comp_ids = _.uniq(comp_ids);
		if (comp_ids.length == 0) {
			delete params['competition_ids'];
			router.push({name: router.currentRoute.value.name, params: params});
		}
	}
}, { deep: true });


watch(() => dateTimeSportFiltersStore.sort, (new_value, old_value) => {
	if (new_value == 'time') {
		dateTimeSportFiltersStore.fetchTimeFixtures({ competition_ids: router.currentRoute.value.params.competition_ids});
	}

});


const initTimeSort = async () => {
	if (router.currentRoute.value.name != 'pre-sports-coupons-competitions-from-to') return;
	if (dateTimeSportFiltersStore.time_fixtures.length === 0) await dateTimeSportFiltersStore.fetchTimeFixtures(router.currentRoute.value.params);
	await nextTick();
	setupIntersectionObserver();
};


const refetch = async (mounted = false) => {
	if (router.currentRoute.value.params.sport_id != preSportsStore.selected_pre_sport_id) dateTimeSportFiltersStore.selected_regions = [];
	if (router.currentRoute.value.params.sport_id) preSportsStore.setSelectedPreSportId(router.currentRoute.value.params.sport_id);

	let competition_ids =  router.currentRoute.value.params.competition_ids ? router.currentRoute.value.params.competition_ids.split(',') : null

	if (mounted) {
		await dateTimeSportFiltersStore.fetchUpcomingDaysInfo(competition_ids)
	} else {
		dateTimeSportFiltersStore.fetchUpcomingDaysInfo(competition_ids)
	}

	if (router.currentRoute.value.params.from) {
		let date_from = router.currentRoute.value.params.from;

		dateTimeSportFiltersStore.date_from = date_from
		dateTimeSportFiltersStore.selected_option = date_from;

		dateTimeSportFiltersStore.setSelectedOptionByDates(date_from);
	} else {
		dateTimeSportFiltersStore.date_from = 'all'
		dateTimeSportFiltersStore.selected_option = 'all';
	}


	if (dateTimeSportFiltersStore.selected_option == 'all') {
		dateTimeSportFiltersStore.date_from = 'all';
		if (router.currentRoute.value.params.sport_id) {
			regionsStore.fetchRegions(router.currentRoute.value.params.sport_id).then(() => {
				if (router.currentRoute.value.params.competition_ids) dateTimeSportFiltersStore.setSelectedRegionsFromIds(router.currentRoute.value.params.competition_ids.split(','));
				else dateTimeSportFiltersStore.selected_regions = [];
			});
		}
	} else {
		await dateTimeSportFiltersStore.fetchCompetitionsPerRegion(router.currentRoute.value.params.competition_ids);
		if (competition_ids) dateTimeSportFiltersStore.setSelectedRegionsFromIds(competition_ids);
		else dateTimeSportFiltersStore.selected_regions = [];
	}

	if (dateTimeSportFiltersStore.sort == 'time') {
		dateTimeSportFiltersStore.clearTimeFixtures();
		dateTimeSportFiltersStore.fetchTimeFixtures(router.currentRoute.value.params);
	}

}
onMounted(async () => {
	await refetch(true);
})

const fetchFixtures = () => {
	dateTimeSportFiltersStore.fetchCompetitionsPerRegion();
	if (dateTimeSportFiltersStore.date_from == null) dateTimeSportFiltersStore.date_from = 'all';
	router.push({
		name: router.currentRoute.value.name,
		params: {
			...router.currentRoute.value.params,
			competition_ids: dateTimeSportFiltersStore.selected_regions.flatMap(region => region.competition_ids).filter(id => id).join(','),
			from: dateTimeSportFiltersStore.date_from || moment.utc().format('YYYY-MM-DD HH:mm'),
			to: dateTimeSportFiltersStore.date_to || 'end_of_time'
		}
	});

	closeAllFilters();
}


watch(route, (to, from) => {
	refetch();
});

const clearCompetitionFilters = () => {
	dateTimeSportFiltersStore.selected_regions = [];
	dateTimeSportFiltersStore.fetchUpcomingDaysInfo();
}

const calculateHeight = () => {
	if (dateTimeSportFiltersStore.expand_competitions) return 'calc(100dvh - 280px)';
	if (dateTimeSportFiltersStore.expand_datetime) return 'calc(100dvh - 280px)';
	return '';
}

const appleShenanigans = () => {
	if (initializeStore.isAppleMobile && window_height.value < 850) return '100px';
	return '';
}

onUnmounted(() => {
	document.body.classList.remove('filters-show');
})
</script>
<template>

	<div class="filters-container">
		<div class="filters-left" @click="toggleFilter('datetime')">
			<p class="selected-filter-day">{{ showTranslatedDateFilter }}</p>
			<div :class="['icon', { 'rotated': dateTimeSportFiltersStore.expand_datetime }]"></div>
		</div>

		<div class="filters-middle" @click="toggleFilter('competitions')">
			<p>{{ t('general.competitions') }}</p>
			<div class="filters-middle-container">
				<div class="indicator" v-if="totalSelectedCompetitions > 0">
					{{ totalSelectedCompetitions }}
				</div>
				<div :class="['icon', { 'rotated': dateTimeSportFiltersStore.expand_competitions }]"></div>
			</div>
		</div>

		<div class="filters-right" @click="toggleFilter('sort')">
			<p>{{ $t('general.sort') }}</p>
			<div :class="['icon', { 'rotated': dateTimeSportFiltersStore.expand_sort }]"></div>
		</div>
	</div>

	<transition name="fade">
		<div v-if="dateTimeSportFiltersStore.expand_datetime || dateTimeSportFiltersStore.expand_competitions || dateTimeSportFiltersStore.expand_sort" class="dropdown-backdrop" @click="closeAllFilters"></div>
	</transition>

	<div class="dropdown-wrapper" :style="{ height: calculateHeight() }">
		<transition name="slide-down">
			<div v-if="dateTimeSportFiltersStore.expand_datetime" class="dropdown-menu" :style="{ paddingBottom: appleShenanigans() }">
				<DayTimeFilter @close-filters="closeAllFilters()"/>
			</div>
		</transition>

		<transition name="slide-down">
			<div v-if="dateTimeSportFiltersStore.expand_competitions" class="dropdown-menu">
				<CompetitionFilter />
			</div>
		</transition>

		<transition name="slide-down">
			<div v-if="dateTimeSportFiltersStore.expand_sort" class="dropdown-menu">
				<SortFilter />
			</div>
		</transition>
	</div>

	<Transition name="slide-up">
		<div v-if="dateTimeSportFiltersStore.expand_datetime || dateTimeSportFiltersStore.expand_competitions" class="quick-buttons-clear">
			<button class="btn btn-primary btn-clear" @click="clearCompetitionFilters()">{{$t('general.reset')}}</button>
			<button class="btn btn-primary btn-show" @click="fetchFixtures()" :disabled="dateTimeSportFiltersStore.showButtonCount == 0">{{$t('general.show_lowercase')}} ({{dateTimeSportFiltersStore.showButtonCount}})</button>

		</div>
	</Transition>
</template>
<style scoped>
	.filters-container {
		margin-top: 8px;
		padding: 12px;
		background-color: var(--dark);
		border-bottom: 1px solid var(--tab-gray);
		border-top: 1px solid var(--tab-gray);
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
	}

	.filters-container p {
		color: var(--white);
		font-size: 14px;
		font-weight: 700;
		padding: 3px 0px;
	}

	.filters-left {
		flex: 2;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-right: 1px solid var(--tab-gray);
		gap: 10px;
		padding: 0px 5px;
		cursor: pointer;
	}

	html[dir="rtl"] .filters-left {
		border-left: 1px solid var(--tab-gray);
		border-right: none;
	}



	.filters-middle {
		flex: 3;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-right: 1px solid var(--tab-gray);
		gap: 10px;
		padding: 0px 5px;
		cursor: pointer;
	}

	html[dir="rtl"] .filters-middle {
		border-right: none;
		border-left: 1px solid var(--tab-gray);
	}

	.filters-middle-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 5px;
	}

	.filters-right {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		padding: 0px 5px;
		cursor: pointer;
	}

	.indicator {
		background-color: var(--primary);
		color: var(--white);
		font-weight: bold;
		font-size: 10px;
		width: 19px;
		height: 19px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;

		flex-shrink: 0;
	}

	.icon {
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 7px solid var(--input-gray);
		border-bottom: 0;
		transition: transform 0.3s ease;
	}

	.icon.rotated {
		transform: rotate(180deg);
	}

	.dropdown-wrapper {
		position: absolute;
		width: 100%;
		background: var(--dark);
		color: var(--white);
		font-family: sans-serif;
		z-index: 100;
	}

	.dropdown-menu {
		background: var(--dark);
		overflow-y: auto;
		height: 100%;
		/* max-height: 420px; */
	}

	.dropdown-backdrop {
		position: absolute;
		top: 200px;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		backdrop-filter: blur(4px);
		-webkit-backdrop-filter: blur(4px);
		z-index: 99;
	}

	/* Backdrop Fade Animation */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s ease;
	}

	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
	}

	/* Dropdown Slide Animation */
	.slide-down-enter-active,
	.slide-down-leave-active {
		transition: all 0.3s ease-out;
		max-height: 1000px; /* Large enough to fit content */
		overflow-y: auto;
	}

	.slide-down-enter-from,
	.slide-down-leave-to {
		max-height: 0;
		opacity: 0;
		transform: translateY(-10px);
	}

	.quick-buttons-clear {
		display: flex;
		justify-content: space-evenly;
		gap: 10px;
		padding: 12px 12px;
		background: var(--dark);
		position: fixed;
		bottom: 56px;
		/* z-index: 100; */
		width: 100%;
		border-top: 1px solid var(--tab-gray);
		z-index: 200;
	}

	.btn-show {
		background: var(--primary);
		border-color: var(--primary);
		padding: 7.5px 12px;
		border-radius: 4px;
		font-size: 14px;
		width: 40%;
		cursor: pointer;
		opacity: 1;
	}

	.btn-show:disabled {
		cursor: default;
		background: transparent;
		border-color: var(--tab-gray);
		opacity: 0.5;
	}

	.btn-clear {
		padding: 7.5px 12px;
		border-radius: 4px;
		font-size: 14px;
		width: 40%;
		cursor: pointer;
	}

	@media (pointer: fine) {
		.btn-clear:hover {
			background: var(--secondary);
			border-color: var(--secondary);
		}
	}

	.coupon-checkbox-outer:hover {
		background-color: var(--primary);
		border-color: var(--primary);
	}

	.coupon-checkbox-outer span {
		font-size: 12px;
		font-weight: 700;
	}

	.coupon-checkbox-outer .selected {
		background-color: var(--primary);
		border-color: var(--primary);
	}

	.country-flag {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		overflow: hidden;
		display: flex;
		align-items: center;
	}

	.country-flag img {
		width: 18px;
		height: 28px;
		-o-object-fit: cover;
		object-fit: cover;
		-o-object-position: center;
		object-position: center;
	}

	:deep(.splide__arrow:disabled) {
		display: none !important;
	}

	@media screen and (min-width: 320px) and (max-width: 767px) {
		:deep(.splide__arrows .splide__arrow--next) {
			right: 0px !important;
		}
	}

	@media screen and (min-width: 320px) and (max-width: 767px) {
		:deep(.splide__arrows .splide__arrow--prev) {
			left: 0px !important;
		}
	}

	.selected-filter-day {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

</style>